import { MDCRipple } from '@material/ripple/index';
import { MDCList } from '@material/list';
export class FarmhandMcw {
    constructor() {
        this.waitForDocument();
    }

    private waitForDocument(): void {
        if (
            document.readyState === 'complete' ||
            (document.readyState !== 'loading' && !(document.documentElement as any).doScroll)
        ) {
            this.initialize();
        } else {
            document.addEventListener('DOMContentLoaded', this.initialize);
        }
    }

    private initialize = (): void => {
        this.bindToWindow();
    };

    private bindToWindow(): void {
        (window as any).mdwc = {
            dialog: {
                open: (selector: string) => {
                    const dialog = document.querySelector(selector) as any;
                    if (dialog && dialog.show) {
                        dialog.show();
                    }
                },
                close: (selector: string) => {
                    const dialog = document.querySelector(selector) as any;
                    if (dialog && dialog.close) {
                        dialog.close();
                    }
                }
            },
            snackbar: {
                open: (selector: string) => {
                    const snackbar = document.querySelector(selector) as any;
                    if (snackbar) {
                        snackbar.open = true;
                    }
                },
                close: (selector: string) => {
                    const snackbar = document.querySelector(selector) as any;
                    if (snackbar) {
                        snackbar.open = false;
                    }
                }
            },
            menu: {
                open: (selector: string) => {
                    const menu = document.querySelector(selector) as any;
                    if (menu) {
                        menu.open = true;
                    }
                },
                close: (selector: string) => {
                    const menu = document.querySelector(selector) as any;
                    if (menu) {
                        menu.open = false;
                    }
                }
            }
        };
    }
}
